// Auto-generated by scripts/gen-build-id.mjs (prebuild) — do not edit.
export const BUILD_ID: string = "f54bb7d87ab0";
